module.exports = __webpack_public_path__ + "img/author.6ae536e3.png";